import { getClientsList } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage } from "./ui";

//Загрузка списка клиентов
export const CONS_CLIENTS_LOADING_START = "Consultant's clients loading start";
export const CONS_CLIENTS_LOADING_SUCCESS = "Consultant's  clients list loading success";
export const CONS_CLIENTS_LOADING_FAILED = "Failure during consultant's clients list load";

//Пагинация
export const CHANGE_CONS_CLIENTS_PAGE = "Change consultant's clients page";
export const CHANGE_CONS_CLIENTS_LIMIT = "Change consultant's clients limit";

//Сортировка
export const CHANGE_CONS_CLIENTS_SORTING = "Change consultant's clients sorting options";

const startLoading = () => ({
  type: CONS_CLIENTS_LOADING_START 
});

const loadSuccess = clients => ({
  type: CONS_CLIENTS_LOADING_SUCCESS,
  payload: {
    clients: clients || []
  }
});

const loadFailure = () => ({
  type: CONS_CLIENTS_LOADING_FAILED,
});

//Загрузка списка клиентов
export const getConsultantClientsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let clients;
    try {
      const accessToken = localStorage.getItem("accessToken");
      clients = await getClientsList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка клиентов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(clients));
  };
};

//Пагинация на странице списка клиентов
export const changeConsultantClientsPage = activePage => ({
  type: CHANGE_CONS_CLIENTS_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка клиентов
export const changeConsultantClientsLimit = activeLimit => ({
  type: CHANGE_CONS_CLIENTS_LIMIT,
  payload: { activeLimit }
});

//Сортировка
export const changeConsultantClientsSorting = (sort, order) => ({ 
  type: CHANGE_CONS_CLIENTS_SORTING,
  payload: { sort, order }
});